import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ProgressBar from "@ramonak/react-progress-bar";
import FleetHelper from 'features/Fleet/fleetHelper';

ChargeLimitCard.propTypes = {
    value: PropTypes.number,
    maxValue: PropTypes.number,
    completed: PropTypes.number,
    bgColor: PropTypes.string,
    baseBgColor: PropTypes.string,
    period: PropTypes.string,
};

function ChargeLimitCard({ value = 0, maxValue = 100, completed = 0, bgColor = '#30BD6F', baseBgColor = '#DBDFF1', period = 'MONTH' }) {
    // MARK: ---- PROPERTIES ----

    return (
        <div
            className="overflow-hidden position-relative"
            style={{
                border: `1px solid ${AppColors.gray[300]}`,
                borderRadius: '10px',
                backgroundColor: bgColor,
            }}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                    marginBottom: '5px',
                }}
            >
                {/* header */}
                <div
                    className="px-4 pt-6 pb-4 d-flex flex-column align-items-start"
                    style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                    }}
                >
                    <div
                        className="p-4"
                        style={{
                            backgroundColor: bgColor,
                            borderRadius: '10px',
                        }}
                    >
                        <i className="fa-solid fa-2x fa-gauge-circle-bolt text-white" />
                    </div>
                    <div className="mt-4">
                        <span style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>
                            Hạn mức sạc
                        </span>
                    </div>
                </div>
                {/* body */}
                <div className="d-flex flex-column gap-2 w-100 p-4">
                    <div className='d-flex justify-content-between'
                        style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[700])}
                    >
                        <div>
                            Hạn mức/{FleetHelper.Utils.getCreditLimitPeriodName(period).toLowerCase()}
                        </div>
                        <div>
                            VNĐ
                        </div>
                    </div>
                    <ProgressBar
                        width='100%'
                        height={12}
                        labelSize={10}
                        completed={completed}
                        maxCompleted={100}
                        bgColor={bgColor}
                        baseBgColor={baseBgColor}
                        labelColor={'#FFFFFF'}
                        labelAlignment={completed <= 30 ? '' : 'right'}
                    />

                    <div className='d-flex justify-content-between'>
                        <div style={UIHelper.buildFontStyle('600', '14px', bgColor)}>
                            {Utils.formatNumber(value)}
                        </div>
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                            {Utils.formatNumber(maxValue)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChargeLimitCard;
